var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLock(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    transform: "translate(2 5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.161266,1.2711114 C3.317977,1.2711114 4.255745,1.2711114 0.838721,1.2711114 C0.377416,1.2711114 0,1.63511166 0,2.08000052 L0,12.1911127 C0,12.6360016 0.377416,13 0.838721,13 L12.161266,13 C12.622584,13 13,12.6360016 13,12.1911127 L13,2.08000052 C13,1.63511166 12.622584,1.2711114 12.161266,1.2711114 Z M11.322545,11.3822229 L1.677416,11.3822229 L1.677416,2.88888964 L11.322545,2.88888964 L11.322545,11.3822229 Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 5,
    x: 6,
    y: 5,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 6.5,
    r: 1.5
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M8.5,1.60583263 C6.7528999,1.68111589 5.55773341,3.04242304 5.55773341,5.02798117 L5.55773341,6.41017507 L4,6.41017507 L4,5.02798117 C4,2.28793479 5.62997143,0.317878245 8.02904862,0.0350383507 C8.14187006,0.012123787 8.25429803,0 8.36580526,0 C8.41076088,0 8.45549409,0.000561151351 8.5,0.00167824292 C8.54450591,0.000561151351 8.58923912,0 8.63419474,0 C8.74570197,0 8.85812994,0.012123787 8.97095138,0.0350383507 C11.3700286,0.317878245 13,2.28793479 13,5.02798117 L13,6.41017507 L11.4422666,6.41017507 L11.4422666,5.02798117 C11.4422666,3.04242304 10.2471001,1.68111589 8.5,1.60583263 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLock);
export default __webpack_public_path__ + "static/media/icon_lock.99540701.svg";
export { ForwardRef as ReactComponent };